import { createCategoryLandingDefaultFormFields } from '../common/formFields'
import { getGenericCodeTemplatePreset } from '../common/genericPresets'
import { getCategoryLandingHeroImage } from '../common/heroImages'

export function getCoverageAnalysisPreset(presetKey = 'default') {
  if (presetKey === 'lead-gen-fullbleed') {
    return getGenericCodeTemplatePreset('COVERAGE_ANALYSIS', 'lead-gen-fullbleed')
  }
  if (presetKey === 'basic-template-4' || presetKey === 'basic-template-5') {
    return getGenericCodeTemplatePreset('COVERAGE_ANALYSIS', presetKey)
  }
  if (presetKey === 'clean-form') {
    return {
      key: 'coverage-analysis-clean-form',
      category: 'COVERAGE_ANALYSIS',
      name: '보장분석 기본 템플릿 2 - 간편 문의형',
      heroTitle: '내 보험의 중복·누락 보장을 기준표로 점검합니다',
      heroSubtitle: '가입 중인 보험을 기준으로 보장 공백, 중복 담보, 보험료 지속 가능성을 정리해 상담 방향을 안내합니다.',
      heroImageFileId: getCategoryLandingHeroImage('COVERAGE_ANALYSIS'),
      formTitle: '보장 점검 상담 신청',
      contentSections: [
        {
          type: 'benefit-cards',
          title: '상담에서 확인하는 기준',
          items: [
            { icon: '🛡️', title: '보장 공백', description: '질병·상해·생활 위험에서 비어 있는 보장 영역을 확인합니다.' },
            { icon: '🔁', title: '중복 담보', description: '유사한 담보가 여러 계약에 반복되어 있는지 구분합니다.' },
            { icon: '📉', title: '보험료 지속 가능성', description: '현재 납입 구조가 장기적으로 유지 가능한지 함께 봅니다.' },
          ],
        },
      ],
      formFields: createCategoryLandingDefaultFormFields(),
      surveyCustomFields: [
        { id: 'q1', type: 'select', label: '현재 보험 가입 상태는?', required: false, options: ['생명보험', '손해보험', '건강보험', '여러 개 가입', '잘 모르겠음'] },
      ],
      customConfig: {
        templateStyle: 'clean-form',
        heroBackgroundColor: '#f4f8ff',
        heroTextColor: '#0f172a',
        heroSubtitleColor: '#1d4ed8',
        formBorderColor: '#2563eb',
        formBorderWidth: 3,
      },
    }
  }

  if (presetKey === 'hanwha-sections') {
    return {
      key: 'coverage-analysis-hanwha-sections',
      category: 'COVERAGE_ANALYSIS',
      name: '보장분석 기본 템플릿 3 - 설명형',
      heroTitle: '가입 중인 보험을 기준으로 보장 구조를 정리합니다',
      heroSubtitle: '보험증권과 현재 상황을 바탕으로 부족한 보장, 겹치는 담보, 유지가 필요한 항목을 차분히 구분합니다.',
      heroImageFileId: getCategoryLandingHeroImage('COVERAGE_ANALYSIS'),
      formTitle: '보장 점검 신청',
      contentSections: [
        {
          type: 'icon-grid',
          title: '',
          columns: 3,
          items: [
            { icon: '📄', title: '가입 내역 정리', description: '여러 보험증권을 기준별로 나눠 구조를 확인합니다.' },
            { icon: '📊', title: '우선순위 판단', description: '먼저 보완할 항목과 유지할 항목을 구분합니다.' },
            { icon: '💬', title: '상담 방향 안내', description: '무조건 가입 권유가 아닌 점검 결과 중심으로 안내합니다.' },
          ],
        },
        {
          type: 'testimonial',
          title: '상담 시 자주 확인하는 내용',
          items: [
            { name: '확인 1', content: '질병·상해·배상 등 생활 위험별 보장 공백이 있는지 확인합니다.' },
            { name: '확인 2', content: '같은 목적의 담보가 반복되어 보험료 부담을 키우는지 살펴봅니다.' },
          ],
        },
      ],
      formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
      surveyCustomFields: [
        { id: 'q1', type: 'select', label: '현재 보험 가입 상태는?', required: false, options: ['생명보험', '손해보험', '건강보험', '여러 개 가입', '잘 모르겠음'] },
        { id: 'q2', type: 'textarea', label: '가장 궁금한 점은 무엇인가요?', required: false, placeholder: '예: 중복 보장, 부족한 보장' },
      ],
      customConfig: {
        templateStyle: 'hanwha-sections',
        heroBackgroundColor: '#eef6ff',
        heroTextColor: '#111827',
        heroSubtitleColor: '#1d4ed8',
        formBorderColor: '#2563eb',
        formBorderWidth: 3,
        highlightsBackgroundColor: '#f8fafc',
        recommendedTitle: '추천상품',
      },
    }
  }

  return {
    key: 'coverage-analysis-default',
    category: 'COVERAGE_ANALYSIS',
    name: '보장분석 기본 템플릿 1 - 일반형',
    heroTitle: '내 보험의 중복·누락 보장을 기준표로 점검합니다',
    heroSubtitle: '현재 가입 내역을 기준으로 보장 공백, 중복 담보, 보험료 지속 가능성을 정리합니다.',
    heroImageFileId: getCategoryLandingHeroImage('COVERAGE_ANALYSIS'),
    formTitle: '보장분석 상담 신청',
    contentSections: [
      {
        type: 'text',
        title: '보장분석에서 먼저 보는 것',
        content: '보장분석은 새 상품을 먼저 권하는 과정이 아니라, 현재 가입한 보험이 어떤 위험을 얼마나 커버하는지 확인하는 과정입니다. 보험증권, 가족 구성, 소득과 지출, 최근 건강 이슈를 함께 보며 상담 방향을 정리합니다.',
      },
      {
        type: 'benefit-cards',
        title: '점검 기준',
        items: [
          { icon: '🛡️', title: '보장 공백', description: '현재 생활에서 먼저 대비해야 할 위험이 비어 있는지 봅니다.' },
          { icon: '🔁', title: '중복 담보', description: '비슷한 목적의 보장이 반복되어 있는지 확인합니다.' },
          { icon: '📉', title: '보험료 지속 가능성', description: '장기적으로 유지 가능한 납입 구조인지 검토합니다.' },
        ],
      },
      {
        type: 'process-steps',
        title: '상담 절차',
        steps: [
          { number: 1, icon: '📝', title: '기본 정보 확인', description: '연락처와 상담 가능 시간, 현재 고민을 확인합니다.' },
          { number: 2, icon: '📊', title: '가입 구조 점검', description: '보험증권 기준으로 공백·중복·유지 항목을 구분합니다.' },
          { number: 3, icon: '💬', title: '상담 방향 안내', description: '필요한 경우 보완 방향과 유의사항을 설명드립니다.' },
        ],
      },
    ],
    formFields: createCategoryLandingDefaultFormFields({ includeMessage: true }),
    surveyCustomFields: [
      { id: 'q1', type: 'select', label: '현재 보험 가입 상태는?', required: false, options: ['생명보험', '손해보험', '건강보험', '여러 개 가입', '잘 모르겠음'] },
      { id: 'q2', type: 'textarea', label: '가장 궁금한 점은 무엇인가요?', required: false, placeholder: '예: 중복 보장, 부족한 보장' },
    ],
    customConfig: {
      templateStyle: 'default',
      heroBackgroundColor: '#f8fafc',
      heroTextColor: '#0f172a',
      heroSubtitleColor: '#475569',
    },
  }
}
